module.exports = __webpack_public_path__ + "static/media/icon-excel.e26bdda7.jpg";